import { useState } from 'react';
import { Progress } from '@/components/ui/atoms/progress';
import { Slider } from '@/components/ui/atoms/slider';
import MLoader from '@/components/ui/atoms/MLoader';

const ProgressTest = () => {
  const [progressValue, setProgressValue] = useState(60);

  return (
    <div className="p-8 bg-neutral-10 min-h-screen">
      <h1 className="text-2xl font-bold text-primary-indigo-600 mb-6">Progress Bar Component Test</h1>
      
      <section className="mb-8">
        <h2 className="text-lg font-medium text-primary-indigo-600 mb-4">Progress Bar Sizes</h2>
        <div className="flex flex-col gap-8 p-6 border border-neutral-30 rounded-md bg-white max-w-2xl">
          {/* Small Progress Bar */}
          <div>
            <h3 className="text-sm font-medium mb-2">Small (h-1)</h3>
            <Progress value={75} size="sm" />
          </div>
          
          {/* Medium Progress Bar (Default) */}
          <div>
            <h3 className="text-sm font-medium mb-2">Medium (h-2, Default)</h3>
            <Progress value={50} />
          </div>
          
          {/* Large Progress Bar */}
          <div>
            <h3 className="text-sm font-medium mb-2">Large (h-3)</h3>
            <Progress value={25} size="lg" />
          </div>
        </div>
      </section>
      
      <section className="mb-8">
        <h2 className="text-lg font-medium text-primary-indigo-600 mb-4">Progress Bar with Label and Value</h2>
        <div className="flex flex-col gap-8 p-6 border border-neutral-30 rounded-md bg-white max-w-2xl">
          {/* With Label */}
          <div>
            <Progress value={65}>Uploading files...</Progress>
          </div>
          
          {/* With Value */}
          <div>
            <Progress value={40} showValue />
          </div>
          
          {/* With Label and Value */}
          <div>
            <Progress value={80} showValue>Download progress</Progress>
          </div>
        </div>
      </section>
      
      <section className="mb-8">
        <h2 className="text-lg font-medium text-primary-indigo-600 mb-4">Interactive Progress Bar</h2>
        <div className="p-6 border border-neutral-30 rounded-md bg-white max-w-2xl">
          <div className="mb-6">
            <Progress value={progressValue} showValue size="lg">Adjust the slider to change progress</Progress>
          </div>
          
          <div className="py-4">
            <Slider
              defaultValue={[progressValue]}
              max={100}
              step={1}
              onValueChange={(value) => setProgressValue(value[0])}
            />
          </div>
        </div>
      </section>
      
      <section className="mb-8">
        <h2 className="text-lg font-medium text-primary-indigo-600 mb-4">Progress States</h2>
        <div className="flex flex-col gap-8 p-6 border border-neutral-30 rounded-md bg-white max-w-2xl">
          {/* Empty */}
          <div>
            <h3 className="text-sm font-medium mb-2">Empty (0%)</h3>
            <Progress value={0} showValue />
          </div>
          
          {/* Partial */}
          <div>
            <h3 className="text-sm font-medium mb-2">Partial (33%)</h3>
            <Progress value={33} showValue />
          </div>
          
          {/* Half */}
          <div>
            <h3 className="text-sm font-medium mb-2">Half (50%)</h3>
            <Progress value={50} showValue />
          </div>
          
          {/* Almost Complete */}
          <div>
            <h3 className="text-sm font-medium mb-2">Almost Complete (90%)</h3>
            <Progress value={90} showValue />
          </div>
          
          {/* Complete */}
          <div>
            <h3 className="text-sm font-medium mb-2">Complete (100%)</h3>
            <Progress value={100} showValue />
          </div>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-lg font-medium text-primary-indigo-600 mb-4">MLoader (Centered Loader Spinner)</h2>
        <div className="p-6 border border-neutral-30 rounded-md bg-white max-w-2xl min-h-[200px] flex items-center justify-center">
          {/* Demo: Show loader spinner centered */}
          <MLoader />
        </div>
      </section>
    </div>
  );
};

export default ProgressTest;
